(function(){
  if (window.__lx) return; window.__lx = 1;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('lx-js');
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  function run(){ document.querySelectorAll('.lx-rv:not(.is-in)').forEach(function(el){ io.observe(el); }); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
